import { TransportManagerAccountProfileComponent } from "./transport-manager-account-profile/transport-manager-account-profile.component";
import { TransportManagerAccountComponent } from "./transport-manager-account.component";
import { TransportManagerChangePasswordComponent } from "./transport-manager-change-password/transport-manager-change-password.component";
import { ProfileMobileChangeComponent } from "./profile-mobile-change/profile-mobile-change.component";


export const TransportManagerAccountDeclaration = [
    TransportManagerAccountComponent,
    TransportManagerChangePasswordComponent,
    TransportManagerAccountProfileComponent, 
    
    ProfileMobileChangeComponent
    
];